import InPersonInterviewAddressType from "@/models/JobWorkerInterviews/InPersonInterviewAddressType";

export default (value: InPersonInterviewAddressType) => {
    switch (value) {
        case InPersonInterviewAddressType.CompanyAddress:
            return "Other Company Address";
        case InPersonInterviewAddressType.JobInterviewAddress:
            return "Job Interview Address";
        case InPersonInterviewAddressType.JobLocation:
            return "Job Location";
        case InPersonInterviewAddressType.OtherLocation:
            return "Other Company Location";
        case InPersonInterviewAddressType.OtherAddress:
            return "Other Address";
        default:
            return "Unknown";
    }
} 